// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"126":"94032f27","421":"306e5c84","534":"f0c259c8","583":"029902f7","601":"4ce07371","808":"0a8f9ec0","891":"8f859fb5","918":"a049a9d8"}[chunkId] + ".chunk.css";
};